import { LoanType } from '../LoanConstants';

export const getLoanExtensionPeriod = (loanTypeId: LoanType) => {
    switch (loanTypeId) {
        case LoanType.Rental:
        case LoanType.BuildRent:
            return 24;
        case LoanType.Construction:
        case LoanType.FixFlip:
        case LoanType.Land:
            return 4;
        default:
            return 0;
    }
};
